import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useTemplateFontSettings } from 'styles/templateFontSettings';

function ReportSubjectGroupsTable({ data }) {

  const { baseFontSize } = useTemplateFontSettings()

  return (
    <Table size="small"
      sx={{ marginBottom: 3, marginTop: 1, borderRadius: 3, lineHeight: 1, fontSize: baseFontSize }}>
      <TableHead sx={{ backgroundColor: "lightgrey" }}>
        <TableRow>
          <TableCell align="left" sx={{ fontSize: baseFontSize }}>Konu</TableCell>
          <TableCell align="left" sx={{ fontSize: baseFontSize }}>Madde Sayısı</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((item, index) => (
          <TableRow key={index}>
            <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.subjectName}</TableCell>
            <TableCell align="left" sx={{ fontSize: baseFontSize }}>{item.decisionCount}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}

export default ReportSubjectGroupsTable;